/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex, Text } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Auth from 'solis/auth';

import Login from 'solis/auth/login';

import { getConfig } from 'solis/auth/firebase';


export default () =>
{
  const status = use(Auth(auth => auth.status));

  return (
    <Flex direction = 'column' align = 'center' justify = 'center' gap = '3' p = '6'>
      {status === Auth.SignedOut
        ? <Login config = {getConfig()} />
        : <Text size = '2' color = 'gray'>Connecting to server…</Text>}
    </Flex>
  );
};
